import { parseForReviewTimeField, getTodaysDate, getCookie } from './../../../config/utils';
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import dateformat from 'dateformat';
import { AppState } from "../../../../store";
import { AnyAction } from "redux";
import megatron from "@stencil/megatron";
import { review, pricereview, blockapi, reviewsApi, goTribeUrlPath, UPDATE_GOTRIBE_DETAILS, UPDATE_GOTRIBE, SOURCE_TYPE } from "../../../config/constants";
import { pageView } from "../../../config/ga";
import { generateTimeList, timeAMPMToTime } from "../../../config/utils";
import { UPDATE_PAYDATA } from '../../SeoPage/redux/seo-action-types';
import { getter } from '@stencil/client-side-storage';

export const fetchReview = (isAutosuggest): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    dispatch({
      type: "UPDATE_LOADER_STATE",
      loaders: {
        review: true,
        pay: true,
      },
    });
    const url = `${__ENV_CONFIG__["__GOCARS__"]}${review}`;
    const { common = {}, srp = {}, review: reviewApi = {} } = getState();
    const { reviewResults = {} } = reviewApi;
    const { selectedCab = {} } = srp;
    const { dispatchSearchId = "", key = "", vehicle_type = "",is_ryde } = selectedCab;
    const { source = {}, tripType = {}, destination: cDesc = {}, startDate = {}, endDate = {}, isSeo = false, flow = '', package_id } = common;
    const { date: sd = new Date(), time: sTime = '' } = startDate;
    const { date: ed = new Date(), time: eTime = '' } = endDate;
    const newDate = timeAMPMToTime(sd, sTime);
    const isTimePassed = new Date() > newDate ? getTodaysDate() : sd;
    const newTime = generateTimeList(isTimePassed.getHours(), isTimePassed.getMinutes());
    const newSTime = new Date() > newDate ? newTime[0] : sTime;
    const newETime = new Date() > newDate ? newTime[1]: eTime;
    const {
      destination_id = "",
      destination = "",
      start_time = "",
      end_time = "",
    } = reviewResults;
    const {
      place_id: source_id = "",
      name: source_name = "",
      loc_type = "",
      types = [],
    } = source;
    const headers = {
      Authorization: "Basic Zm9vOmJhcg==",
      "content-type": "application/json",
    };
    const {
      place_id: destId = "",
      name: destination_name = "",
    } = cDesc;

    const seacrhQuery = {
      source_name,
      source_id,
      start_time,
      end_time,
      trip_type: tripType?.name,
      rf: tripType?.rf,
      destination_id,
      destination_name: destination,
    };
    const seoQuery = {
      source_name,
      source_id,
      destination_id: destId?.length ? destId : destination_id,
      destination_name: destination_name?.length ? destination_name : destination,
      vehicle_type,
      trip_type: tripType?.name,
      rf: tripType?.rf,
      start_time: start_time ? start_time : `${dateformat(sd, 'yyyy-mm-dd')} ${parseForReviewTimeField(newSTime)}`,
			end_time: tripType?.rf === 'rt' ? end_time ? end_time : `${dateformat(ed, 'yyyy-mm-dd')} ${parseForReviewTimeField(newETime)}` : "",
      is_ryde
    }
    const searchData = isSeo ? seoQuery : seacrhQuery;
    const searchId = {
      search_id: dispatchSearchId
    };
    const src_type = getter(SOURCE_TYPE) || []
    const commonData = {
      flavour: "cars_dweb",
      vehicle_key: key,
      skip_payment_modes: true,
      tracking_id: "",
      src_loc_type: loc_type,
      src_type: types?.length ? types : (src_type || []),
      seo_flow: !!isSeo,
      flow_name: flow?.length ? flow : "direct-cabs"
    };

    if (tripType?.rf === 'hr') {
      commonData['package_id'] = package_id
    }
    const data = isAutosuggest || (isSeo && !dispatchSearchId) ? { ...commonData, ...searchData } : { ...commonData, ...searchId };
    try {
      const response = await megatron({
        name: "cars review",
        type: "POST",
        credentials: 'include',
        url,
        requestData: JSON.stringify(data),
        headers,
      });
      let newResponse = response;
      if (isAutosuggest) {
        const isAdreesUpdate = 'Great! Your pickup address is updated successfully!';
        newResponse = { ...newResponse, isAdreesUpdate };
      }
      const isError = !!(response?.error_type && response?.error_type?.toUpperCase() === 'SEO' && isSeo);
      if (selectedCab?.dispatchSearchId?.length && selectedCab?.dispatchSearchId !== response?.dispatch_search_id) {
        const reviewUrl = window.location.href.replace(selectedCab?.dispatchSearchId, response?.dispatch_search_id)
        window.history.replaceState(null, "", reviewUrl);
      }
      dispatch({
        type: "UPDATE_REVIEW_RESPONSE",
        reviewResults: newResponse,
        loaders: {
          review: isError,
          pay: isError,
        }
      });
      if (!isError) {
        dispatch(fetchPriceResults(response.dispatch_search_id, response.key));
      }
    } catch (err) {
      dispatch({
        type: "UPDATE_LOADER_STATE",
        loaders: {
          review: false,
          pay: false,
        },
      });
      console.info(err);
    }
  };
};

export const fetchPriceResults = (
  search_id = "",
  searchKey = ""
): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    dispatch({
      type: "UPDATE_LOADER_STATE",
      loaders: {
        pay: true,
      },
    });
    const url = `${__ENV_CONFIG__["__GOCARS__"]}${pricereview}`;
    const { review: reviewApi = {}, srp = {}, common = {} } = getState();
    const { sem_flow = false, isSeo = false, flow = '' } = common;
    const { reviewResults = {}, reviewSelectedData = {} } = reviewApi;
    const { dispatch_search_id = "", key = "" } = reviewResults;
    const { promocode = "", apply_gocash = false } = reviewSelectedData;
    const { selectedCab = {} } = srp;
    const { pc = '' } = selectedCab;
    const headers = {
      Authorization: "Basic Zm9vOmJhcg==",
      "content-type": "application/json",
    };
    const data = {
      flavour: "cars_dweb",
      search_id: search_id || dispatch_search_id,
      vehicle_key: searchKey || key,
      skip_payment_modes: true,
      tracking_id: "",
      promoCode: promocode || pc || "",
      apply_wallet: apply_gocash,
      sem_flow,
      seo_flow: isSeo,
      flow_name: flow?.length ? flow : "direct-cabs"
    };
    try {
      const response = await megatron({
        name: "carsreviewprice",
        type: "POST",
        credentials: 'include',
        url,
        requestData: JSON.stringify(data),
        headers,
      });
      dispatch({
        type: "UPDATE_FARE_DETAILS",
        priceDetails: response,
      });
    } catch (err) {
      dispatch({
        type: "UPDATE_LOADER_STATE",
        loaders: {
          review: false,
          pay: false,
        },
      });
      console.info(err);
    }
  };
};

export const fetchBlockApi = (gstinDetails = {}): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    dispatch({
      type: "UPDATE_LOADER_STATE",
      loaders: { isBlockapi: true },
    });
    const url = `${__ENV_CONFIG__["__GOCARS__"]}${blockapi}`;
    const { review = {}, common = {} } = getState();
    const {
      reviewSelectedData = {},
      reviewResults = {},
      travellerDetails = {},
      priceDetails = {}
    } = review;
    const { flow = '', sem_flow = false, isSeo = false, tripType = {}, package_id = ""  } = common;
    const {
      first_name = "",
      last_name = "",
      email = "",
      phone_number = "",
      gender = "M",
    } = travellerDetails;
    const {
      dispatch_search_id = "",
      trip_type = "",
      key = "",
      toll_paid = ""
    } = reviewResults;
    const {
      apply_gocash = true,
      is_part_payment = false,
      insurance_opted = "",
      s_r = [],
      isConsentAvailable = false
    } = reviewSelectedData;
    const { promo_details = {} } = priceDetails;
    const { Applied = false, Code = "" } = promo_details || {};
    const headers = {
      Authorization: "Basic Zm9vOmJhcg==",
      "content-type": "application/json",
    };
    // const gen = gender === 'Mr' ? 'M' : 'F';
    const data = {
      search_id: dispatch_search_id,
      passengers: [{ first_name: first_name, last_name: last_name, gender: gender, email, phone_number: phone_number }],
      apply_gocash,
      toll_paid: !!toll_paid,
      trip_type: tripType?.rf === "hr" ? "LOCAL_RENTAL" : trip_type,
      flavour: "cars_dweb",
      promocode: Applied ? Code : '',
      is_part_payment,
      // rf,
      insurance_opted: !!insurance_opted,
      // flight_xsell_info, // 
      // loyalty_info, // layout info needs to be confirmed
      vehicle_key: key,
      s_r,
      flow_name: flow?.length ? flow : "direct-cabs",
      is_consent_available: isConsentAvailable,
      sem_flow,
      seo_flow: isSeo
    };

    if (tripType?.rf === 'hr') {
      data['package_id'] = package_id
    }

    if (Object.keys(gstinDetails)?.length) {
      data['gstinDetails'] = gstinDetails
    }
    
    try {
      const response = await megatron({
        name: "carsreviewprice",
        type: "POST",
        credentials: "include",
        url,
        requestData: JSON.stringify(data),
        headers,
      });
      if (response?.error?.title && response?.error?.cta_1?.action) {
        dispatch({
          type: "UPDATE_REVIEW_RESPONSE",
          reviewResults: {
            ...reviewResults,
            popup: {
              t: response?.error?.title,
              st: response?.error?.subtitle,
              cta1: {
                text: response?.error?.cta_1?.text,
                action: response?.error?.cta_1?.action
              }
            }
          },
          loaders: {
            review: false,
            pay: false,
            isBlockapi: false
          }
        });
   
      } else {
        dispatch({
          type: "UPDATE_LOADER_STATE",
          loaders: { isBlockapi: false },
        });
        const { final_amount = 0, paydata = {} } = response;
        const { pay_id = "", surl = "",internal_pay_url="" } = paydata;
        if (final_amount === 0 && surl) {
          window.location.replace(surl);
          return
        }
        if(internal_pay_url){// this condition is to support the new payment flow handled by common's team
          window.location.href = internal_pay_url;
          return;
        }
        if (window.initPayment) {
          window.initPayment({
            paySessionId: pay_id,
            containerId: "gi_paymentframe",
          });
          dispatch({
            type: UPDATE_PAYDATA,
            paydata: paydata
          });
          dispatch(pageView('goCarsPaymentOptionScreen'));
        } else {
          alert('Payments failed');
   
        }
      }
    } catch (err) {
      console.info(err);
      alert('Block api failed');
      
    }
  };
};

export const fetchReviewsData = (link = ""): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const { review = {} } = getState();
    const { reviews: reviewData = {} } = review || {};
    const { reviews = [], pageNumber = 0 } = reviewData || {};
     const postData = {
      endpoint: link,
      page_number: pageNumber + 1
    }
    const url = `${__ENV_CONFIG__["__GOCARS__"]}${reviewsApi}`;
    const headers = {
      Authorization: "Basic Zm9vOmJhcg==",
      "content-type": "application/json",
    };
    try {
      dispatch({
        type: "UPDATE_LOADER_STATE",
        loaders: {
          isReviewsApi: true
        },
      });
      const response = await megatron({
        name: "carsreviewprice",
        type: "POST",
        credentials: "include",
        url,
        requestData: JSON.stringify(postData),
        headers,
      });
      dispatch({
        type: "UPDATE_LOADER_STATE",
        loaders: {
          isReviewsApi: false
        },
      });
      if (!response?.error) {
        const newResponse = response?.response;
        if (pageNumber === 0) {
          dispatch({
            type: "UPDATE_REVIEWS_DATA",
            reviews: {
              ...reviewData,
              title: newResponse?.title,
              reviews: newResponse?.reviews,
              pageNumber: pageNumber + 1
            }
          });
        } else {
          dispatch({
            type: "UPDATE_REVIEWS_DATA",
            reviews: {
              ...reviewData,
              reviews: [...reviews, ...newResponse?.reviews],
              pageNumber: pageNumber + 1
            }
          });
        }
      } else {
        dispatch({
          type: "UPDATE_REVIEWS_DATA",
          reviews: {
            ...reviewData,
            hasMore: false
          }
        });
      }
    } catch (e) {
      console.log(e)
    }
  };
};

export const fetchTribeDetails = ({pageName}): ThunkAction<void,AppState,{},AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const { common = {}, review= {} } = getState();
    const { startDate = {} } = common ;
    const { date: sd = new Date() } = startDate;

    const { priceDetails ={}, reviewResults = {} } = review;
    const { payment_options = {} } = priceDetails;
    const { Full = {}} = payment_options;
    const { amount = '' } = Full;
    const {trip_type = ''} = reviewResults;
  if(!(+amount)){
    return;
  }
    const tripTypeForLoayalityInfo = function(){

      let type = ''
      switch(trip_type){
        case 'ONE_WAY':
          type='OS_1way_Cabs'
          break;
        case 'ROUND_TRIP':
          type='OS_Roundtrip_Cabs';
          break;
        case 'AIRPORT':
          type='AT_Cabs';
          break;
        case 'LOCAL_RENTAL':
          type='HR_Cabs'
          break;
        case 'SD':
          type='SD_Cabs'
          break;
        default:
          break;
      }
      return type;
  
    }();

    var auth = getCookie('OAUTH-GOIBIBO');
    
    const url = `${__ENV_CONFIG__["__GOTRIBEURL__"]}${goTribeUrlPath}`;
    const headers = {
			Authorization: "7NP82fpV0TsA9JrK",
			'content-type': 'application/json',
      org: "GI",
      region: "IND",
      auth: auth || "",
		};

    const data = { 
        "bookingDate": new Date().getTime(), 
        "bookingAmount": amount, 
        "travelDate": sd.getTime(), 
        "group": "CAB", 
        "bookingCategory": tripTypeForLoayalityInfo,//"DOMESTIC", 
        "pageType": pageName, 
        "pah": false, 
        "lobParams": null, 
        "bookingId": null, 
        "source": "caller", 
        "platform": "desktop" 
      } 
    try {
      var options = {
        headers,
        method: 'POST',
        body: JSON.stringify(data)
      };
      const request = new Request(url);
      const rawResponse = await fetch(request, options);
      const response = await rawResponse.json();
      if(response && typeof response == 'object'){
        if(response?.errors && response?.errors?.length==0){
          dispatch({
            type: UPDATE_GOTRIBE_DETAILS,
            tribeDetails: {
              tribeData: response,
              showTribeData: true,
            }
          });
        }else{
          dispatch({
            type: UPDATE_GOTRIBE,
            showTribeData: false,
          });
        }
      }else{
        dispatch({
          type: UPDATE_GOTRIBE,
          showTribeData: false,
        });
      }
    } catch (err) {
      console.info("err", err);
    }
  };
};